import { queryOptions, useQuery, useSuspenseQuery } from "@tanstack/react-query"
import { getStudentYearPeriodAttendance } from "./api"

export const studentYearPeriodAttendanceQueryOptions = (studentNo: string) =>
    queryOptions({
        queryKey: ['studentYearPeriodAttendance', studentNo],
        queryFn: () => getStudentYearPeriodAttendance(studentNo),
    })

export function useStudentYearPeriodAttendance(studentNo: string) {
    return useQuery(studentYearPeriodAttendanceQueryOptions(studentNo))
}

export function useStudentYearPeriodAttendanceSuspense(studentNo: string) {
    return useSuspenseQuery(studentYearPeriodAttendanceQueryOptions(studentNo))
}
